export const RECRUITER_INSIGHTS_COLOR = "#00B0C2"
